import { RestrictedExportingSettingTypeDetailsFragment } from 'generated/graphql';

export const StateName = 'CampaignContextState';

export interface CampaignContextState {
  current_campaign: {
    id: string;
    name: string;
    showCustomIds?: boolean;
    defaultCountry?: string;
    restrictedExportingSettings?: RestrictedExportingSettingTypeDetailsFragment;
    showElectoralDistricts?: boolean;
    allowOrganizersToExport?: boolean;
    defaultEntityType: { id: string };
    activityStreamAsInitialEntityView?: boolean;
    entityConnectionTypes?: Array<{ id: string }>;
    calendarEventsEnabled?: boolean;
  };
}

export const initialState: CampaignContextState = {
  current_campaign: null
};
